function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "64",
  height: "64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.334 23.267c0-12.126 9.837-21.934 22-21.934 12.162 0 22 9.808 22 21.934 0 16.45-22 40.733-22 40.733s-22-24.283-22-40.733z",
  fill: "#eb1700"
}), /*#__PURE__*/React.createElement("rect", {
  x: "14.666",
  y: "6.667",
  width: "33.333",
  height: "33.333",
  rx: "16.667",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: "14.666",
  y: "6.667",
  width: "33.333",
  height: "33.333",
  rx: "16.667",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.721 30.758a1.136 1.136 0 00-1.068-.644c-.286-.554-.747-1.447-1.023-1.986-.618-1.208-1.478-1.02-1.936-.8l-.562.314a50.91 50.91 0 00-.587-.813l-.19-.257-.638.39a9.444 9.444 0 00-2.267-1.957 8.075 8.075 0 00-3.568-.816c-1.205 0-2.411.252-3.568.816-2.967 1.82-4.49 5.072-5.48 8.828h2.507c.963-5.102 3.132-6.802 3.132-6.802l-.812 6.802h8.441l-.812-6.802s.343.269.817.914l-.311.19 1.256 3.727.786-.36c.22.684.42 1.458.584 2.331h2.508c-.3-1.139-.65-2.231-1.074-3.252l.84-.384-.17-.326a17.238 17.238 0 00-.88-1.476l.454-.254c.206-.098.42-.186.72.4.274.534.727 1.413 1.014 1.968a1.136 1.136 0 101.887.249zm-4.587-.592l-1.3.584c-.258.087-.46-.259-.69-.892l-.543-1.413 1.57-.952c.402.55.828 1.153 1.22 1.791a.621.621 0 01-.257.882zM29.901 22.894a3.553 3.553 0 003.55-3.55 3.552 3.552 0 00-3.55-3.544 3.551 3.551 0 00-3.544 3.55 3.542 3.542 0 003.544 3.544zm0-5.805a2.265 2.265 0 012.262 2.261 2.265 2.265 0 01-2.262 2.262 2.26 2.26 0 110-4.523z",
  fill: "#eb1700"
}), /*#__PURE__*/React.createElement("defs", {
  id: "defs3"
}, /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "clipPath3"
}, /*#__PURE__*/React.createElement("rect", {
  x: "14.666",
  y: "6.667",
  width: "33.333",
  height: "33.333",
  rx: "16.667",
  fill: "#fff",
  id: "rect4"
})))));